export default __webpack_public_path__ + "static/media/Q14.4a8798bc.jpg";